import { createSlice } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage';

const initialState = {
    userData: [],
    skillSections: [],
    quiz: {},
    moduleID: "",
    lessonID: "",
    skillID: "",
    skillName: "",
    subSkillID: "",
    subSkillName: "",
    session: "",
    quizPoints: 0,
    loading: false,
    error: false,
    moduleName: "",
    correctLetters: [],
    existLetters: [],
    absentLetters: [],
    words: [],
    chatbot: {},
    register: false,
    lesson: {},
    module: {},
    skill: {},
    isNextEnabled: false,
    hasWaitTime: true,
    waitTime: 30,
    notifications: []
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setRegister: (state, action) => {
            state.register = action.payload
        },
        setData: (state, action) => {
            state.userData = action.payload
            state.loading = false
            state.userData?.data?.map(module => {
                if (module._id === state.moduleID) {
                    state.module = module
                    module?.lessons?.map(lesson => {
                        if (lesson?._id === state.lessonID) {
                            state.lesson = lesson
                            if (lesson.isCompleted) {
                                state.words = lesson?.words
                            }
                            lesson?.skills?.map(skill => {
                                if (skill._id === state.skillID) {
                                    state.skillName = skill?.name;
                                    state.skill = skill
                                    skill?.subSkills?.map(subSkill => {
                                        if (subSkill._id === state.subSkillID) {
                                            state.subSkillName = subSkill?.name;

                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        },
        setSkillSections: (state, action) => {
            let temp = []
            state.quiz = action.payload.quiz
            if (action.payload.skillSections[0].isCompleted) {
                state.skillSections = action.payload.skillSections
            } else {
                action.payload.skillSections.map((ss, i) => {
                    if (i === 0) {
                        temp.push({
                            _id: ss._id,
                            name: ss.name,
                            allContent: ss.allContent,
                            isEnrolled: true,
                            isCompleted: false,
                        })
                    } else {
                        temp.push({
                            _id: ss._id,
                            name: ss.name,
                            allContent: ss.allContent,
                            isEnrolled: false,
                            isCompleted: false,
                        })
                    }
                })
                state.skillSections = temp;
            }

        },
        setIDs: (state, action) => {
            state.moduleID = action.payload.module
            state.lessonID = action.payload.lesson
            state.skillID = action.payload.skill
            state.subSkillID = action.payload.subSkill
        },
        setSession: (state, action) => {
            state.session = action.payload
        },
        setSkillName: (state, action) => {
            state.skillName = action.payload
        },
        setSubSkillName: (state, action) => {
            state.subSkillName = action.payload
        },
        setQuizPoints: (state, action) => {
            state.quizPoints += action.payload
        },
        emptyPoints: (state) => {
            state.quizPoints = 0
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setModuleName: (state, action) => {
            state.moduleName = action.payload
        },
        setCorrectLetters: (state, action) => {
            let index = state.correctLetters.findIndex(x => x === action.payload)
            if (index === -1) {
                state.correctLetters = [...state.correctLetters, action.payload]
            }

        },
        setExistLetters: (state, action) => {
            let index = state.existLetters.findIndex(x => x === action.payload)
            if (index === -1) {
                state.existLetters = [...state.existLetters, action.payload]
            }
        },
        setAbsentLetters: (state, action) => {
            let index = state.absentLetters.findIndex(x => x === action.payload)
            if (index === -1) {
                state.absentLetters = [...state.absentLetters, action.payload]
            }

        },
        removeAllLetters: state => {
            state.correctLetters = []
            state.existLetters = []
            state.absentLetters = []
        },
        setWords: (state, action) => {
            state.words = action.payload
        },
        setChatbot: (state, action) => {
            state.chatbot = action.payload
        },
        userEnroll: (state, action) => {
            let temp = []
            let index = false
            state.skillSections.map((ss, i) => {
                if (ss._id === action.payload) {
                    index = true;
                    temp.push({
                        _id: ss._id,
                        name: ss.name,
                        allContent: ss.allContent,
                        isEnrolled: true,
                        isCompleted: true,
                    })
                } else {
                    if (index) {
                        temp.push({
                            _id: ss._id,
                            name: ss.name,
                            allContent: ss.allContent,
                            isEnrolled: true,
                            isCompleted: false,
                        })
                        index = false
                    } else {
                        temp.push(ss)
                    }
                }
            })
            state.skillSections = temp;
        },
        emptyStore: (state) => {
            state.userData = [];
            state.skillSections = [];
            state.quiz = {};
            state.moduleID = "";
            state.lessonID = "";
            state.skillID = "";
            state.skillName = "";
            state.subSkillID = "";
            state.subSkillName = "";
            state.session = "";
            state.quizPoints = 0;
            state.loading = false;
            state.error = false;
            state.moduleName = "";
            state.correctLetters = [];
            state.existLetters = [];
            state.absentLetters = [];
            state.words = [];
            state.chatbot = {};
            state.register = false;
            state.lesson = {};
            state.module = {};
            state.skill = {};
        },
        setNextEnabled: (state, action) => {
            state.isNextEnabled = action?.payload
        },
        setOrganization: (state, action) => {
            let organizations = action.payload
            let user = state.userData?.user
            if (!user || !organizations?.length) {
                return;
            }
            let organization = {}
            organizations?.map(org => {
                if (org?._id === user?.OrganizationId) {
                    organization = org
                }
            })
            console.log("ORganization: ", organization)
            if (user?._id === organization?.testing_user || organization?.wait_time === 0) {
                state.hasWaitTime = false
            } else {
                state.hasWaitTime = true
            }
            state.waitTime = organization?.wait_time

        },
        setNotifications: (state, action) => {
            let tempNotifications = []
            let notifications = action.payload?.reverse()
            notifications?.map(item => {
                if (state.notifications?.length) {

                    let fn = state.notifications.find(noti => noti._id === item._id)
                    if (fn) {
                        tempNotifications.push({
                            ...item,
                            status: fn?.status
                        })
                    } else {
                        tempNotifications.push({
                            ...item,
                            status: 'unread'
                        })
                    }
                } else {
                    tempNotifications.push({
                        ...item,
                        status: 'unread'
                    })
                }
            })
            state.notifications = [...tempNotifications]

        },
        setAllAsReadNotification: (state) => {
            let tempNotifications = []
            state.notifications?.map(item => {
                tempNotifications.push({
                    ...item,
                    status: 'read'
                })
            })
            state.notifications = [...tempNotifications]
        },
        setAsReadNotification: (state, action) => {
            let tempNotifications = []
            state.notifications?.map(item => {
                if (action.payload === item._id) {
                    tempNotifications.push({
                        ...item,
                        status: 'read'
                    })
                } else {
                    tempNotifications.push(item)
                }
            })
            state.notifications = [...tempNotifications]
        },
        setAsUnReadNotification: (state, action) => {
            let tempNotifications = []
            state.notifications?.map(item => {
                if (action.payload === item._id) {
                    tempNotifications.push({
                        ...item,
                        status: 'unread'
                    })
                } else {
                    tempNotifications.push(item)
                }
            })
            state.notifications = [...tempNotifications]
        }
    },

})

export const {
    setNextEnabled,
    emptyStore,
    userEnroll,
    setSubSkillName,
    emptyPoints,
    setSkillName,
    setData,
    setSkillSections,
    setIDs,
    setSession,
    setQuizPoints,
    setLoading,
    setModuleName,
    setCorrectLetters,
    setExistLetters,
    setAbsentLetters,
    removeAllLetters,
    setWords,
    setChatbot,
    setRegister,
    setOrganization,
    setNotifications,
    setAllAsReadNotification,
    setAsReadNotification,
    setAsUnReadNotification
} = userSlice.actions

export default userSlice.reducer